/** האם לדלג על אנימציות: המשתמש ביקש תנועה מופחתת, או סביבת טסט (jsdom) —
 *  טסטים בודקים ערכים סופיים ו-unmount מיידי, לא פריימים ביניים. */
export function motionDisabled(): boolean {
  if (import.meta.env.MODE === 'test') return true;
  return typeof window !== 'undefined' && !!window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
}
